export type Vocabulary = { [k: string]: string };

export type Creds = {
  password: string;
  username: string;
};

export type Props = {
  /**
   * Alternative to location state for manual redirect
   */
  originalPath?: string;
  /**
   * Overrides the primary auth title if provided.
   */
  primaryAuthTitle?: string;
  /**
   * Default is `true`. Set to `false` if you do not want errors to be thrown explicitly
   */
  throwErrors?: boolean;
};

export const customTranslationKeys = [
  'OktaWidget.PrimaryAuthTitle',
  'OktaWidget.FailedLoginAttempts',
  'OktaWidget.FailedLoginWarning',
  'OktaWidget.BadUsernamePassword',
  'OktaWidget.LockedOut',
  'OktaWidget.PrimaryAuthSubmit',
  'OktaWidget.OldPasswordPlaceholder',
  'OktaWidget.OldPasswordTooltip',
  'OktaWidget.UsernamePlaceholder',
  'OktaWidget.PasswordPlaceholder',
  'OktaWidget.forgotpassword',
  'OktaWidget.confirmPasswordPlaceholder',
  'OktaWidget.confirmPasswordTooltip',
  'OktaWidget.newPasswordPlaceholder',
  'OktaWidget.newPasswordTooltip',
  'OktaWidget.passwordExpiredSubmit',
  'OktaWidget.Signout',
  'OktaWidget.ExpiredTitleGeneric',
  'OktaWidget.ValidationFieldBlank',
  'OktaWidget.ErrorMatch',
  'OktaWidget.ErrorbannerTitle',
  'OktaWidget.ExpiredSession',
  'OktaWidget.UsernameRequired',
  'OktaWidget.PasswordRequired',
  'OktaWidget.ComplexityRequirementsHeader',
  'OktaWidget.ComplexityNumber',
  'OktaWidget.ComplexitySymbol',
  'OktaWidget.ComplexityNoUsername',
  'OktaWidget.ComplexityHistory',
  'OktaWidget.ComplexityLowercaseDescription',
  'OktaWidget.ComplexityUppercaseDescription',
  'OktaWidget.ComplexityUppercase',
  'OktaWidget.ComplexityLength',
  'OktaWidget.ComplexityLengthDescription',
  'OktaWidget.RememberDeviceTimebased',
  'OktaWidget.InvalidPasscode',
];

export const supportedLanguages = [
  'en-US',
  'es-US',
  'en-CA',
  'fr-CA',
  'es-MX',
  'en-MX',
  'pt-BR',
  'en-BR',
  'es-CO',
  'en-CO',
  'es-PE',
  'en-PE',
  'es-CL',
  'en-CL',
  'es-USME',
  'en-USME',
  'es-ES',
  'en-ES',
  'de-AT',
  'en-AT',
  'de-DE',
  'en-DE',
  'fr-FR',
  'en-FR',
  'sv-SE',
  'en-SE',
  'it-IT',
  'en-IT',
  'en-GB',
  'en-UK',
  'pt-PT',
  'en-PT',
  'en-BE',
  'fr-BE',
  'nl-BE',
  'nl-NL',
  'en-NL',
  'de-CH',
  'fr-CH',
  'it-CH',
  'en-CH',
  'hu-HU',
  'en-HU',
  'fi-FI',
  'en-FI',
  'da-DK',
  'en-DK',
  'en-SG',
  'en-NZ',
  'en-AU',
  'en-MY',
  'en-HK',
  'hi-IN',
  'en-IN',
  'id-ID',
  'en-ID',
  'zh-CN',
  'en-CN',
  'th-TH',
  'en-TH',
];
